export default [
    {
        path: '/evaluate',
        component: () => import('@/views/evaluate')
    },
    {
        path: '/evaluate/:id',
        props: (route) => ({
            id:  Number(route.params.id),
           
        }),
        component: () => import('@/views/evaluate/detail')
    },
    {
        path: '/evaluate/:id/edit',
        props: (route) => ({
            id:  Number(route.params.id),
            
        }),
        component: () => import('@/views/evaluate/edit')
    },
]